import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';
import { Link } from '@mui/material';

export const Page = styled('div')`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  padding: 0 30px;
  width: 100vw;

  @media (max-width: ${breakpoints.mobileXL}) {
    height: 100dvh;
    padding: 0 15px;
  }
`;

export const LogoSection = styled('div')`
  align-items: center;
  display: flex;
  flex: 1;
  height: 70px;
  position: absolute;
  justify-content: center;
  width: 100%;
`;

export const LogoButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
`;

export const Logo = styled('img')`
  height: 26px;

  @media (max-width: ${breakpoints.mobileXL}) {
    height: 22px;
  }
`;

export const CardSection = styled('div')`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
  width: 100%;
`;

export const BottomSection = styled('div')`
  display: flex;
  flex: 1;
  gap: 30px;
  justify-content: space-between;
  padding: 20px 35px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const BottomButton = styled('div')`
  align-items: center;
  background: none;
  border: none;
  color: black;
  cursor: pointer;
  display: flex;
  gap: 5px;

  svg path {
    stroke: black;
  }

  &:hover {
    p {
      color: ${colours.primary[500]};
    }
    svg path {
      stroke: ${colours.primary[500]};
    }
  }
`;

export const HelpLink = styled(Link)`
  color: black;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  text-decoration-color: black;
`;
